{
  "productName": "KVox",
  "tagline": "From voice to knowledge.",
  "repoSlug": "marinoscar/kvox",
  "themeColor": "#4f46e5",
  "backgroundColor": "#ffffff",
  "cliName": "kvox"
}
